<template>
<div>
    <div class="mcc-page-header" >
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mcc-row">
                <section class="mcc-col mu-d-flex mu-flex-row mu-align-items-center">
                    <h1 class="mu-mb-00">Settings</h1>

                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
 
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

                </section>
                <section>


                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <div>
            <nav aria-label="breadcrumb" class="">
                <ol class="mcc-breadcrumb">
                    <li>Administration</li>
                    <li aria-current="page">Settings</li>
                    <li class="lastBredCrumpLi"></li>
                </ol>
            </nav>
        </div>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>
        <div class="mcc-row" v-if="fetchCall">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <form novalidate ref="adminSettingsForm" id="adminSettingsForm" @submit.prevent="saveSettings()">
                        <div class="mcc-tabs mcc-tabs--compact mcc-tabs--bar">
                            <input type="radio" id="as-default-tab1" name="as-default-tab-control" checked="">
                            <input type="radio" id="as-default-tab2" name="as-default-tab-control">
                            <input type="radio" id="as-default-tab3" name="as-default-tab-control">
                            <ul role="tablist" class="mu-bg-container-01 mu-pt-07 mu-pl-06 mu-radius-top-02 mu-border-top mu-border-start mu-border-end">
                                <li role="tab">
                                    <label for="as-default-tab1" tabindex="0">
                                        <span>General</span>
                                    </label>
                                </li>
                                <li role="tab">
                                    <label for="as-default-tab2" tabindex="0">
                                        <span>Mail Server</span>
                                    </label>
                                </li>
                            </ul>
                            <div role="tabpanel">
                                <div class="mcc-card mu-radius-top-00">
                                    <div class="mcc-card__body">
                                        <ul class="mcc-list-group mcc-list-group--lg">
                                            <li v-for="(genSetting,key) in defaultSetings.appConfigpropertiesList" :key="key" v-bind:class="{'d-none':checkForToggleValue(genSetting)}">
                                                <div class="mcc-row mu-align-items-center">
                                                    <div class="mcc-col mu-fw-semi-bold">{{getDisplayName(genSetting.appConfigPropertyDisplayName)}}</div>
                                                    <div class="mcc-col">
                                                        <div class="mcc-row" v-if="genSetting.appConfigPropertyName != 'sendEmailNotification' && genSetting.appConfigPropertyName != 'enablePrivacyPolicy' && genSetting.appConfigPropertyName != 'enableClamAV'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                                    <label :for="'appConfigpropertiesList'+key+'.appConfigPropertyValue'">Value</label>
                                                                    <input class="mfc-input" type="text" required="" :pattern="valueRegex" :ref="genSetting.appConfigPropertyName + 'ValueRef'" :readonly="genSetting.appConfigPropertyValue == 'SYSTEMADMINISTRATORS'" :id="'appConfigpropertiesList'+key+'.appConfigPropertyValue'" :name="'appConfigpropertiesList['+key+'].appConfigPropertyValue'" :value="genSetting.appConfigPropertyValue" @change="updatePropertyValue($event, genSetting)">
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div class="mcc-row" v-if="genSetting.appConfigPropertyName == 'sendEmailNotification'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                                    <input type="checkbox" class="mfc-switch" id="sendEmailNotificationToggle" :name="'appConfigpropertiesList['+key+'].appConfigPropertyValue'" :checked="genSetting.appConfigPropertyValue == 'true'" @change="genSetting.appConfigPropertyValue = $event.target.checked">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mcc-row" v-if="genSetting.appConfigPropertyName == 'enablePrivacyPolicy'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                                    <input type="checkbox" id="enablePrivacyPolicyToggle" :name="'appConfigpropertiesList['+key+'].appConfigPropertyValue'" :checked="genSetting.appConfigPropertyValue == 'true'" @change="handleEnablePrivacyPolicyChange($event.target.checked)" class="mfc-switch">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mcc-row" v-if="genSetting.appConfigPropertyName == 'enableClamAV'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                                    <input type="checkbox" id="enableClamAVToggle" :name="'appConfigpropertiesList['+key+'].appConfigPropertyValue'" :checked="genSetting.appConfigPropertyValue == 'true'" @change="handleEnableClamAVChange($event.target.checked)" color="primary" class="mfc-switch">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mcc-col">
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                            <label :for="'appConfigpropertiesList'+key+'.appConfigPropertyDescription'">Description</label>
                                                            <input type="text" required="" :ref="genSetting.appConfigPropertyName + 'DescRef'" :readonly="genSetting.appConfigPropertyValue == 'SYSTEMADMINISTRATORS'" :id="'appConfigpropertiesList'+key+'.appConfigPropertyDescription'" :name="'appConfigpropertiesList['+key+'].appConfigPropertyDescription'" :value="genSetting.appConfigPropertyDescription" @change="updatePropertyDescription($event, genSetting)" :pattern="descRegex">
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mcc-card__footer">
                                        <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end">
                                            <button class="mcc-button mcc-button--success" id="saveBtn1" title="Save" type="submit">
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                            </button>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div role="tabpanel">
                                <div class="mcc-card mu-radius-top-00">
                                    <div class="mcc-card__body">
                                        <ul class="mcc-list-group mcc-list-group--lg">
                                            <li v-for="(mailSetting,key) in defaultSetings.flowableMailServerProperties" :key="key" v-bind:class="{'d-none':checkForMailCredentials(mailSetting)}">
                                                <div class="mcc-row mu-align-items-center">
                                                    <div class="mcc-col mu-fw-semi-bold">{{getDisplayName(mailSetting.appConfigPropertyDisplayName)}}</div>
                                                    <div class="mcc-col">
                                                        <div class="mcc-row" v-if="mailSetting.appConfigPropertyName == 'flowableMailServerCredential'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                                    <input type="checkbox" @change="handleMailCredentialsChage($event.target.checked)" id="flowableMailServerCredentialToggle" :name="'flowableMailServerProperties['+key+'].appConfigPropertyValue'" :checked="mailSetting.appConfigPropertyValue == 'true'" color="primary" class="mfc-switch">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mcc-row" v-if="mailSetting.appConfigPropertyName != 'flowableMailServerPort' && mailSetting.appConfigPropertyName != 'flowableMailServerUseSsl' && mailSetting.appConfigPropertyName != 'flowableMailServerUseTls' && mailSetting.appConfigPropertyName != 'flowableMailServerCredential' && mailSetting.appConfigPropertyName != 'flowableMailServerPassword'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                                    <label :for="'flowableMailServerProperties'+key+'.appConfigPropertyValue'">Value</label>
                                                                    <input type="text" required="" :ref="mailSetting.appConfigPropertyName + 'ValueRef'" :pattern="valueRegex" :id="'flowableMailServerProperties'+key+'.appConfigPropertyValue'" :name="'flowableMailServerProperties['+key+'].appConfigPropertyValue'" :value="mailSetting.appConfigPropertyValue" @change="updateMailSettingValue($event, mailSetting)">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mcc-row" v-if="mailSetting.appConfigPropertyName == 'flowableMailServerPort'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                                    <label :for="'flowableMailServerProperties'+key+'.appConfigPropertyValue'">Value</label>
                                                                    <input type="number" min="0" max="65535" :ref="mailSetting.appConfigPropertyName + 'ValueRef'" required="" :id="'flowableMailServerProperties'+key+'.appConfigPropertyValue'" :name="'flowableMailServerProperties['+key+'].appConfigPropertyValue'" :value="mailSetting.appConfigPropertyValue" @change="updateMailSettingValue($event, mailSetting)">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mcc-row" v-if="mailSetting.appConfigPropertyName == 'flowableMailServerUseTls'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                                    <input type="checkbox" id="flowableMailServerUseTlsToggle" :name="'flowableMailServerProperties['+key+'].appConfigPropertyValue'" :checked="mailSetting.appConfigPropertyValue == 'true'" @change="mailSetting.appConfigPropertyValue = $event.target.checked" color="primary" class="mfc-switch">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mcc-row" v-if="mailSetting.appConfigPropertyName == 'flowableMailServerUseSsl'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                                    <input type="checkbox" id="flowableMailServerUseSslToggle" :name="'flowableMailServerProperties['+key+'].appConfigPropertyValue'" :checked="mailSetting.appConfigPropertyValue == 'true'" @change="mailSetting.appConfigPropertyValue = $event.target.checked" color="primary" class="mfc-switch">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mcc-row" v-if="mailSetting.appConfigPropertyName == 'flowableMailServerPassword' && mailCredentials">
                                                            <div class="mcc-col">
                                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                                    <label :for="'flowableMailServerProperties'+key+'.appConfigPropertyValue'">Value</label>
                                                                    <input type="password" required="" :ref="mailSetting.appConfigPropertyName + 'ValueRef'" :pattern="mailPasswordRegex" :id="'flowableMailServerProperties'+key+'.appConfigPropertyValue'" :name="'flowableMailServerProperties['+key+'].appConfigPropertyValue'" :value="mailSetting.appConfigPropertyValue" @change="updateMailSettingValue($event, mailSetting)">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mcc-col">
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                            <label :for="'flowableMailServerProperties'+key+'.appConfigPropertyDescription'">Description</label>
                                                            <input type="text" required="" :pattern="descRegex" :ref="mailSetting.appConfigPropertyName + 'DescRef'" :id="'flowableMailServerProperties'+key+'.appConfigPropertyDescription'" :name="'flowableMailServerProperties['+key+'].appConfigPropertyDescription'" :value="mailSetting.appConfigPropertyDescription" @change="updateMailSettingDescription($event, mailSetting)">
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mcc-card__footer">
                                        <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end">
                                            <button class="mcc-button mcc-button--success" id="saveBtn2" title="Save" type="submit">
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>

            </div>

        </div>

    </div>
</div>
</template>

<script>
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import AdminSettingsAPI from "../../../services/AdminSettingsAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
export default {
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["admin.settings"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            updateCall: true,
            fetchCall: false,
            defaultSetings: {},
            enablePrivacyPolicy: "false",
            enableClamAV: "false",
            mailCredentials: "false",
            valueRegex: constantMessages.PATTERNS["settingValue"],
            descRegex: constantMessages.PATTERNS["description"],
            mailPasswordRegex: constantMessages.PATTERNS["mailPassword"],
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        var self = this;
        self.fetchCall = false;
        AdminSettingsAPI.getDefaultSettings()
            .then(result => {
                self.defaultSetings = result;

                self.defaultSetings.appConfigpropertiesList.forEach(element => {

                    if (element.appConfigPropertyName.toString().indexOf("Recaptcha") !== -1) {
                        this.removeProperty(element.appConfigPropertyName);
                    }

                    if (element.appConfigPropertyName == "enablePrivacyPolicy") {
                        self.enablePrivacyPolicy = element.appConfigPropertyValue;
                    }
                    if (element.appConfigPropertyName == "enableClamAV") {
                        self.enableClamAV = element.appConfigPropertyValue;
                    }
                });
                self.defaultSetings.flowableMailServerProperties.forEach(element => {
                    if (element.appConfigPropertyName == "flowableMailServerCredential") {
                        self.mailCredentials = element.appConfigPropertyValue;
                    }
                });
            })
            .finally((e) => {
                self.fetchCall = true;
            });
    },
    methods: {
        updatePropertyValue(event, genSetting) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs[genSetting.appConfigPropertyName + 'ValueRef']), constantMessages.MESSAGES["error.value.required"])
                self.$refs[genSetting.appConfigPropertyName + 'ValueRef'][0].classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.valueRegex)) {
                displayErrorMessage($(self.$refs[genSetting.appConfigPropertyName + 'ValueRef']), constantMessages.MESSAGES["error.value.invalid"])
                self.$refs[genSetting.appConfigPropertyName + 'ValueRef'][0].classList.add("ms-is-invalid")
            } else {
                self.$refs[genSetting.appConfigPropertyName + 'ValueRef'][0].classList.remove("ms-is-invalid")
            }
            genSetting.appConfigPropertyValue = event.target.value
        },
        updatePropertyDescription(event, genSetting) {
            let self = this;

            if (event.target.value == "") {
                displayErrorMessage($(self.$refs[genSetting.appConfigPropertyName + 'DescRef']), constantMessages.MESSAGES["error.description.required"])
                self.$refs[genSetting.appConfigPropertyName + 'DescRef'][0].classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs[genSetting.appConfigPropertyName + 'DescRef']), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs[genSetting.appConfigPropertyName + 'DescRef'][0].classList.add("ms-is-invalid")
            } else {
                self.$refs[genSetting.appConfigPropertyName + 'DescRef'][0].classList.remove("ms-is-invalid")
            }
            genSetting.appConfigPropertyDescription = event.target.value
        },
        updateMailSettingValue(event, mailSetting) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs[mailSetting.appConfigPropertyName + 'ValueRef']), constantMessages.MESSAGES["error.value.required"])
                self.$refs[mailSetting.appConfigPropertyName + 'ValueRef'][0].classList.add("ms-is-invalid")
            } else if (event.target.type === 'password' && !event.target.value.match(this.mailPasswordRegex)) {
                displayErrorMessage($(self.$refs[mailSetting.appConfigPropertyName + 'ValueRef']), constantMessages.MESSAGES["error.value.invalid"])
                self.$refs[mailSetting.appConfigPropertyName + 'ValueRef'][0].classList.add("ms-is-invalid")
            } else if (event.target.type === 'number' && event.target.value < event.target.min) {
                displayErrorMessage($(self.$refs[mailSetting.appConfigPropertyName + 'ValueRef']), constantMessages.MESSAGES["error.externalSystemFileConnection.port"])
                self.$refs[mailSetting.appConfigPropertyName + 'ValueRef'][0].classList.add("ms-is-invalid")
            } else if (event.target.type === 'number' && event.target.value > event.target.max) {
                displayErrorMessage($(self.$refs[mailSetting.appConfigPropertyName + 'ValueRef']), constantMessages.MESSAGES["error.externalSystemFileConnection.port.max"])
                self.$refs[mailSetting.appConfigPropertyName + 'ValueRef'][0].classList.add("ms-is-invalid")
            } else if (event.target.type !== 'number' && event.target.type !== 'password' && !event.target.value.match(this.valueRegex)) {
                displayErrorMessage($(self.$refs[mailSetting.appConfigPropertyName + 'ValueRef']), constantMessages.MESSAGES["error.value.invalid"])
                self.$refs[mailSetting.appConfigPropertyName + 'ValueRef'][0].classList.add("ms-is-invalid")
            } else {
                self.$refs[mailSetting.appConfigPropertyName + 'ValueRef'][0].classList.remove("ms-is-invalid")
            }
            mailSetting.appConfigPropertyValue = event.target.value
        },
        updateMailSettingDescription(event, mailSetting) {
            let self = this;

            if (event.target.value == "") {
                displayErrorMessage($(self.$refs[mailSetting.appConfigPropertyName + 'DescRef']), constantMessages.MESSAGES["error.description.required"])
                self.$refs[mailSetting.appConfigPropertyName + 'DescRef'][0].classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs[mailSetting.appConfigPropertyName + 'DescRef']), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs[mailSetting.appConfigPropertyName + 'DescRef'][0].classList.add("ms-is-invalid")
            } else {
                self.$refs[mailSetting.appConfigPropertyName + 'DescRef'][0].classList.remove("ms-is-invalid")
            }

        },
        checkForToggleValue(genSetting) {
            return ((genSetting.appConfigPropertyName == 'privacyPolicyLinkName' || genSetting.appConfigPropertyName == 'privacyPolicyLinkUrl') && this.enablePrivacyPolicy == 'false') || ((genSetting.appConfigPropertyName == 'clamAVHost' || genSetting.appConfigPropertyName == 'clamAVPort') && this.enableClamAV == 'false');
        },
        checkForMailCredentials(mailSetting) {
            return ((mailSetting.appConfigPropertyName == 'flowableMailServerUsername' || mailSetting.appConfigPropertyName == 'flowableMailServerPassword') && this.mailCredentials == 'false');
        },
        removeProperty(name) {
            this.defaultSetings.appConfigpropertiesList = this.defaultSetings.appConfigpropertiesList.filter(item => item.appConfigPropertyName != name);
        },
        handleMailCredentialsChage(checked) {
            var self = this;
            self.mailCredentials = checked ? "true" : "false";
            self.defaultSetings.flowableMailServerProperties.forEach(element => {
                if (element.appConfigPropertyName == "flowableMailServerCredential") {
                    element.appConfigPropertyValue = self.mailCredentials;
                }
                if (!checked) {
                    if (element.appConfigPropertyName == "flowableMailServerUsername" && element.appConfigPropertyValue == "") {
                        element.appConfigPropertyValue = "Mail Server Username";
                        self.$refs.flowableMailServerUsernameValueRef[0].value = "Mail Server Username";
                        $(self.$refs.flowableMailServerUsernameValueRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "flowableMailServerUsername" && element.appConfigPropertyDescription == "") {
                        element.appConfigPropertyDescription = "Mail Server Username";
                        self.$refs.flowableMailServerUsernameDescRef[0].value = "Mail Server Username";
                        $(self.$refs.flowableMailServerUsernameDescRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "flowableMailServerPassword" && element.appConfigPropertyValue == "") {
                        element.appConfigPropertyValue = "Mail Server Password";
                        self.$refs.flowableMailServerPasswordValueRef[0].value = "Mail Server Password";
                        $(self.$refs.flowableMailServerPasswordValueRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "flowableMailServerPassword" && element.appConfigPropertyDescription == "") {
                        element.appConfigPropertyDescription = "Mail Server Password";
                        self.$refs.flowableMailServerPasswordDescRef[0].value = "Mail Server Password";
                        $(self.$refs.flowableMailServerPasswordDescRef[0]).removeAttr("invalid");
                    }
                }
            });
            self.$refs.adminSettingsForm.update();
        },
        handleEnablePrivacyPolicyChange(checked) {
            var self = this;
            self.enablePrivacyPolicy = checked ? "true" : "false";
            self.defaultSetings.appConfigpropertiesList.forEach(element => {

                if (element.appConfigPropertyName == "enablePrivacyPolicy") {
                    element.appConfigPropertyValue = self.enablePrivacyPolicy;
                }
                if (!checked) {

                    if (element.appConfigPropertyName == "privacyPolicyLinkName" && element.appConfigPropertyValue == "") {
                        element.appConfigPropertyValue = "GDPR Privacy Policy";
                        self.$refs.privacyPolicyLinkNameValueRef[0].value = "GDPR Privacy Policy";
                        $(self.$refs.privacyPolicyLinkNameValueRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "privacyPolicyLinkName" && element.appConfigPropertyDescription == "") {
                        element.appConfigPropertyDescription = "Privacy Policy Link Name";
                        self.$refs.privacyPolicyLinkNameDescRef[0].value = "Privacy Policy Link Name";
                        $(self.$refs.privacyPolicyLinkNameDescRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "privacyPolicyLinkUrl" && element.appConfigPropertyValue == "") {
                        element.appConfigPropertyValue = "https://www.oneadvanced.com/privacy-policy/";
                        self.$refs.privacyPolicyLinkUrlValueRef[0].value = "https://www.oneadvanced.com/privacy-policy/";
                        $(self.$refs.privacyPolicyLinkUrlValueRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "privacyPolicyLinkUrl" && element.appConfigPropertyDescription == "") {
                        element.appConfigPropertyDescription = "Privacy Policy Link URL";
                        self.$refs.privacyPolicyLinkUrlDescRef[0].value = "Privacy Policy Link URL";
                        $(self.$refs.privacyPolicyLinkUrlDescRef[0]).removeAttr("invalid");
                    }
                }
            });
            self.$refs.adminSettingsForm.update();
        },
        handleEnableClamAVChange(checked) {
            var self = this;
            self.enableClamAV = checked ? "true" : "false";
            self.defaultSetings.appConfigpropertiesList.forEach(element => {

                if (element.appConfigPropertyName == "enableClamAV") {
                    element.appConfigPropertyValue = self.enableClamAV;
                }
                if (!checked) {
                    if (element.appConfigPropertyName == "clamAVHost" && element.appConfigPropertyValue == "") {
                        element.appConfigPropertyValue = "ClamAV Host";
                        self.$refs.clamAVHostValueRef[0].value = "ClamAV Host";
                        $(self.$refs.clamAVHostValueRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "clamAVHost" && element.appConfigPropertyDescription == "") {
                        element.appConfigPropertyDescription = "ClamAV Host URL.";
                        self.$refs.clamAVHostDescRef[0].value = "ClamAV Host URL.";
                        $(self.$refs.clamAVHostDescRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "clamAVPort" && element.appConfigPropertyValue == "") {
                        element.appConfigPropertyValue = "ClamAV Port";
                        self.$refs.clamAVPortValueRef[0].value = "ClamAV Port";
                        $(self.$refs.clamAVPortValueRef[0]).removeAttr("invalid");
                    }
                    if (element.appConfigPropertyName == "clamAVPort" && element.appConfigPropertyDescription == "") {
                        element.appConfigPropertyDescription = "ClamAV Port.";
                        self.$refs.clamAVPortDescRef[0].value = "ClamAV Port.";
                        $(self.$refs.clamAVPortDescRef[0]).removeAttr("invalid");
                    }
                }
            });
            self.$refs.adminSettingsForm.update();
        },
        getDisplayName(displayName) {
            return constantMessages.DISPLAY_NAME[displayName];
        },
        saveSettings() {
            let form = $('#adminSettingsForm')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let self = this;
            self.updateCall = false;
            AdminSettingsAPI.saveDefaultSettings(self.defaultSetings)
                .then(response => {
                    if (response.error) {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    } else {
                        self.defaultSetings.appConfigpropertiesList.forEach(element => {
                            if (element.appConfigPropertyName == "privacyPolicyLinkName") {
                                self.$store.dispatch("fetchPrivacyPolicyLinkName", element.appConfigPropertyValue);
                            }
                            if (element.appConfigPropertyName == "privacyPolicyLinkUrl") {
                                self.$store.dispatch("fetchPrivacyPolicyLinkUrl", element.appConfigPropertyValue);
                            }
                            if (element.appConfigPropertyName == "enablePrivacyPolicy") {
                                self.$store.dispatch("fetchEnablePrivacyPolicy", element.appConfigPropertyValue);
                            }
                            if (element.appConfigPropertyName == "helpURL") {
                                constantMessages.URL_UTILS.updateRootUrl(element.appConfigPropertyValue);
                                constantMessages.BREADCRUMB_HELP = constantMessages.URL_UTILS.getBreadCrumbHelp();
                                self.$store.dispatch("fetchHelpUrl", element.appConfigPropertyValue);
                                self.helpText = constantMessages.BREADCRUMB_HELP["admin.settings"];
                            }
                        });
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    }
                })
                .finally(() => {
                    self.updateCall = true;
                });
        }
    }
};
</script>

<style scoped>
</style>
